export const texts = {
  statusNames: {
    undecided: { de: 'Unentschieden', en: 'Undecided' },
    accepted: { de: 'Ausgewählt', en: 'Selected' },
    rejected: { de: 'Abgelehnt', en: 'Rejected' }
  }
};
